import * as types from "../mutation-types";
import axios from "axios";
import {reportAxiosError} from "../../helpers";

const state = {

    // Invite
    invite: {
        inviteKey: '',
        valid: false,
        teamReminders: false,
        userReminders: true,
        totalReminders: 50,
        name: '',
    },

    // Account
    account: {
        firstName: '',
        lastName: '',
        email: '',
        country: '',
        acceptedTerms: false,
    },
    acceptedTermsOfService: false,

    // Plans
    plan: null,

    // Reminder
    reminder: null,

};

const getters = {


    invite () {
        return state.invite
    },


    account () {
        return state.account
    },


    acceptedTermsOfService () {
        return state.acceptedTermsOfService
    },


    plan () {
        return state.plan
    },


    reminder () {
        return state.reminder
    },

};

const actions = {

    /**
     * Load the current invite for the session
     *
     * @param commit
     * @param state
     * @param payload
     * @returns {Promise<AxiosResponse<any>>}
     */
    loadInvite ({ commit, state }, payload) {
        if(typeof payload !== 'string' || !payload) {
            payload = '';
        }

        return axios.get('/sign-up/invite?inviteKey=' + payload)
            .then((response) => {
                if(response.status === 200) {
                    response.data.activated = true;

                    if (response.data.valid && localStorage) {
                        localStorage.reminderbotInviteKey = payload;
                    }

                    commit(types.SET_REGISTRATION_INVITE, response.data);
                } else {
                    this.dispatch('messages/handleXHRFailureMessages', {response: response});
                }
            })
            .catch((error) => {
                reportAxiosError(error);
                if (error.response.status !== 404) {
                    this.dispatch('messages/handleXHRFailureMessages', error);
                }
            });
    },

    /**
     * Remove the current invite for the session
     *
     * @param commit
     * @param state
     * @param payload
     * @returns {Promise<AxiosResponse<any>>}
     */
    clearInvite ({ commit, state }, payload) {
        if (localStorage) {
            localStorage.reminderbotInviteKey = '';
        }
        commit(types.SET_REGISTRATION_INVITE, {
            inviteKey: '',
            valid: false,
            teamReminders: false,
            userReminders: true,
            totalReminders: 50,
            name: '',
        });
    },

    /**
     * Load the current reminder for the session
     *
     * @param commit
     * @param state
     * @param payload
     * @returns {Promise<AxiosResponse<any> | never>}
     */
    loadReminder ({ commit, state }, payload) {
        if((typeof payload.force === 'undefined' || !payload.force) && state.reminder) {
            return;
        }

        return axios.get('/sign-up/reminders/current')
            .then((response) => {
                if(response.status === 200) {

                    // NOTE: We use only a basic version of the payload. Once we are on the edit page we'll gather and store the full details
                    let payload = {
                        name: response.data.name,
                    };

                    commit(types.SET_REGISTRATION_REMINDER, payload);
                } else {
                    this.dispatch('messages/handleXHRFailureMessages', {response: response});
                }
            })
            .catch((error) => {
                reportAxiosError(error);
                if (error.response.status !== 404) {
                    this.dispatch('messages/handleXHRFailureMessages', error);
                }
            });
    },


    /**
     * Update the terms of service.
     *
     * NOTE: This is primarily for accepting the terms before the final account details page is shown
     *
     * @param state
     * @param commit
     * @param payload
     */
    updateTermsOfService ({ state, commit }, payload) {
        commit(types.SET_REGISTRATION_TERMS_OF_SERVICE, payload);
    },


    /**
     * Update the plan
     *
     * @param state
     * @param commit
     * @param payload
     */
    updatePlan ({ state, commit }, payload) {
        commit(types.SET_REGISTRATION_PLAN, payload);
    },


    /**
     * Update the reminder
     *
     * @param state
     * @param commit
     * @param payload
     */
    updateReminder ({ state, commit }, payload) {
        commit(types.SET_REGISTRATION_REMINDER, payload);
    },


    /**
     * Show any registration or connection messages
     *
     * @param state
     * @param commit
     * @param payload
     */
    showMessages ({ state, commit }, payload) {
        switch(payload.message) {

            case 'accessDenied':
                this.dispatch('messages/showMessage', {
                    type: 'error',
                    message: 'Your request has been denied. Please try to connect again.'
                });
                break;

            case 'connectionDisabled':
                this.dispatch('messages/showMessage', {
                    type: 'success',
                    message: 'Your integration has been successfully disabled'
                });
                break;

            case 'connected':
                this.dispatch('messages/showMessage', {
                    type: 'success',
                    message: 'Your integration has been successfully enabled'
                });
                break;

            case 'connectionReset':
                this.dispatch('messages/showMessage', {
                    type: 'success',
                    message: 'You\'re ready to start connecting!'
                });
                break;

            case 'welcome':
                this.dispatch('messages/showMessage', {
                    type: 'success',
                    message: 'Welcome back to Reminder Bot!'
                });
                break;

            default:
                this.dispatch('messages/clearMessages');
                break;

        }
    }

};

const mutations = {

    [types.SET_REGISTRATION_INVITE] (state, item) {
        state.invite = item
    },

    [types.SET_REGISTRATION_ACCOUNT] (state, item) {
        state.account = item
    },

    [types.SET_REGISTRATION_TERMS_OF_SERVICE] (state, item) {
        state.acceptedTermsOfService = item
    },

    [types.SET_REGISTRATION_PLAN] (state, item) {
        state.plan = item
    },

    [types.SET_REGISTRATION_REMINDER] (state, item) {
        state.reminder = item
    },

};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
